import React, { useContext, useEffect, useState } from 'react';
import Pipelinetitle from '../../components/Cards/Pipelinetitle';
import Vehiclecard from '../../components/Cards/Vehiclecard';
import Revenuecard from '../../components/Cards/Revenuecard';
import Currentpipeline from '../../components/Cards/Currentpipeline';
import Rtocard from '../../components/Cards/Rtocard';
import Claimcard from '../../components/Cards/Claimcard';
import LoyalPoint from '../../components/Cards/LoyalPointAnalysis';
import Barchartcard from '../../components/Cards/Barchart';
import Piechartcard from '../../components/Cards/Piechartcard';
import logoo from "../../assets/images/RTO-Detail.svg";
import { FilterContext } from '../../context/Filter';
import TanStackTable from '../../components/Table/ClaimnDiscount';
import Modal from '../../components/Modals/Modaltanstack';
import NavButtons from '../../components/NevBar/NavButtons';
import { getintendedapp, getrevenuedetaill } from './pipline&servicekpi';
import { Link } from 'react-router-dom';
import Pipelinetitle2 from '../../components/Cards/pipelinetitle2';
import FinanciarAnalysisBarchart from '../../components/Cards/FinanciarAnalysisBarchart';

const Pipelinecard = () => {
  const [showTable, setShowTable] = useState(false);
  const [popUpTableData, setPopUpTableData] = useState(null);


  const toggleButton = (
    <button
      className=" rounded mb-4"
      onClick={() => setShowTable(!showTable)}
    >
      {showTable ? (
        "x"
      ) : (
        <img src={logoo} style={{ height: "30px" }} className="" />
      )}
    </button>
  );


  return (
    <div className='flex-col'>
      <Modal isOpen={showTable} onClose={() => setShowTable(false)}>
        <TanStackTable />
      </Modal>

      <div className='block mr-3 lg:flex m-1'>
        <Pipelinetitle heading={"Vehicle"} des={<Vehiclecard />} />
        <Pipelinetitle heading={"Revenue Analysis"} des={<Revenuecard />} />
      </div>

      <div className="mr-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 m-1 gap-3">
        <Pipelinetitle heading={"Current Pipeline"} des={<Currentpipeline />} />
        <Pipelinetitle heading={"Financier Analysis"} des={<FinanciarAnalysisBarchart />} />
        <Pipelinetitle heading={"Intended Application"} des={<Piechartcard />} />
      </div>


      <div className='mr-3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 m-1'>
        <Pipelinetitle heading={"Claims & Discount Details"} des={<Claimcard />} button={toggleButton} />
        <Pipelinetitle2 heading={"Loyalty Points Analysis"} des={<LoyalPoint />} button={""} />
        <Pipelinetitle
          heading={"RTO Details"}
          des={<Rtocard />}
          button={
            <Link to="/Rto">
              <img src={logoo} style={{ height: "30px" }} className="mr-2" />
            </Link>
          }
        />
      </div>

      <NavButtons />
    </div>
  );
};



export default Pipelinecard;
